import Lyric from './Lyric'
import padStart from 'lodash-es/padStart'

/**
 * 酷我逐字歌词
 * @see http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272064474753 附件
 */
export default class Lrcx extends Lyric {
  constructor(type = 'lyricKuwo') {
    super(type)
    this._template = `[ver:v1.0]
[ar:__singerName__]
[ti:__trackName__]
[by:__author__]
__content__`

    this.nameExt = '_lrcx'
  }

  /**
   * @override
   */
  _getLineMark(lineTime) {
    const ONE_MINUTE_MILL = 60000
    const startTime = lineTime[0]

    let minute = startTime >= ONE_MINUTE_MILL ? parseInt(startTime / ONE_MINUTE_MILL, 10) : '0'
    minute = padStart(minute, 2, '0')
    let second = parseInt((startTime % ONE_MINUTE_MILL) / 1000, 10)
    second = padStart(second, 2, '0')
    let mill = parseInt((startTime % ONE_MINUTE_MILL) % 1000, 10)
    mill = padStart(mill, 3, '0')

    return `[${minute}:${second}.${mill}]`
  }

  /**
   * @override
   */
  _getWordMark(lineTime, wordObj) {
    const round = Math.round
    const end = wordObj.start + wordObj.duration

    return `<${round(wordObj.start)},${round(end)}>${wordObj.word}`
  }
}
